import { logAmplitudeEvent } from 'amplitude/amplitude'
import { Icon } from 'opensolar-ui'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, DeleteButton, EditButton } from 'react-admin'
import { Link } from 'react-router-dom'
import { utilityTariffVersionEditPathForRecord } from './routing/helpers'

const buttonStyle = { color: '#4d4d4d', justifyContent: 'flex-start', margin: 0, padding: 6 }
const iconButtonStyle = { color: '#4d4d4d', justifyContent: 'flex-start', margin: 0, padding: 6 }

const EditGlyph = () => <Icon icon="edit" size="small" />
const ViewGlyph = () => <Icon icon="visibility" size="small" />
const DuplicateGlyph = () => <Icon icon="content_copy" size="small" />
const ImportGlyph = () => <Icon icon="download" size="small" />

export const UtilityTariffListEditOrImportButton = (allProps) => {
  const {
    allowEdit = true,
    allowDelete = true,
    allowDuplicate = true,
    hideShared = false,
    onDeleteClick = null,
    deleteConfirmContent,
    deleteConfirmTitle,
    versionEditLinks = false,
    ...props
  } = allProps
  const confirmTitle = deleteConfirmTitle ? deleteConfirmTitle(props.record) : undefined
  const isAdmin = props.isAdmin !== false
  const versionEditPath = versionEditLinks && props.record ? utilityTariffVersionEditPathForRecord(props.record) : null
  const logAction = (type) => {
    logAmplitudeEvent('control_crud_action', {
      type: type,
      resource: props.resource,
      variant: 'list_item',
    })
  }
  if (
    (props.record.org && props.record.org.indexOf('/orgs/' + props.org_id + '/') !== -1) ||
    props.record.org_id === props.org_id
  ) {
    const hideLabel = allowDuplicate && isAdmin

    return (
      <div style={{ minWidth: 110 }}>
        {versionEditPath ? (
          <Link style={{ textDecoration: 'none' }} to={versionEditPath}>
            <Button
              style={hideLabel ? iconButtonStyle : buttonStyle}
              color="inherit"
              hideLabelAt={hideLabel ? 'xl' : 'sm'}
              label={allowEdit ? 'Edit' : 'View'}
              onClick={() => {
                logAction(allowEdit ? 'edit' : 'view')
              }}
            >
              {allowEdit ? <EditGlyph /> : <ViewGlyph />}
            </Button>
          </Link>
        ) : (
          <EditButton
            useListStyle={true}
            style={hideLabel ? iconButtonStyle : buttonStyle}
            color="inherit"
            hideLabelAt={hideLabel ? 'xl' : 'sm'}
            {...props}
            icon={allowEdit ? <EditGlyph /> : <ViewGlyph />}
            label={allowEdit ? 'Edit' : 'View'}
            onClick={() => {
              logAction(allowEdit ? 'edit' : 'view')
            }}
          />
        )}

        {isAdmin && allowDuplicate && (
          <Button
            label={'Duplicate'}
            redirect={false}
            hideLabelAt={'xl'}
            submitOnEnter={false}
            variant="text"
            color="inherit"
            style={iconButtonStyle}
            onClick={() => {
              props.duplicate({
                resource: props.resource,
                id: props.record.id,
              })
              logAction('duplicate')
            }}
          >
            <DuplicateGlyph />
          </Button>
        )}
        {allowDelete && (
          <DeleteButton
            onClick={() => {
              logAction('delete')
              if (onDeleteClick) onDeleteClick(props.record)
            }}
            hideLabelAt={hideLabel ? 'xl' : 'sm'}
            style={hideLabel ? iconButtonStyle : buttonStyle}
            undoable={false}
            record={props.record}
            resource={props.resource}
            basePath={props.basePath}
            confirmContent={deleteConfirmContent}
            confirmTitle={confirmTitle}
          />
        )}
        {props.customAction && React.cloneElement(props.customAction, props)}
      </div>
    )
  } else if (!hideShared) {
    return (
      <div>
        {versionEditPath ? (
          <Link style={{ textDecoration: 'none' }} to={versionEditPath}>
            <Button
              style={buttonStyle}
              color="inherit"
              label="View"
              onClick={() => {
                logAction('view')
              }}
            >
              <ViewGlyph />
            </Button>
          </Link>
        ) : (
          <EditButton
            useListStyle={true}
            style={buttonStyle}
            {...props}
            icon={<ViewGlyph />}
            color="inherit"
            label="View"
            onClick={() => {
              logAction('view')
            }}
          />
        )}

        {isAdmin && allowDuplicate && (
          <Button
            label="Import"
            redirect={false}
            submitOnEnter={false}
            style={buttonStyle}
            variant="contained"
            color="inherit"
            onClick={() => {
              props.duplicate({
                resource: props.resource,
                id: props.record.id,
              })
              logAction('import')
            }}
          >
            <ImportGlyph />
          </Button>
        )}
      </div>
    )
  } else {
    return <></>
  }
}

UtilityTariffListEditOrImportButton.propTypes = {
  sortable: PropTypes.bool,
  source: PropTypes.string,
  label: PropTypes.string,
  resource: PropTypes.string,
  allowDuplicate: PropTypes.bool,
  allowEdit: PropTypes.bool,
  allowDelete: PropTypes.bool,
  onDeleteClick: PropTypes.func,
  duplicate: PropTypes.func,
  org_id: PropTypes.number,
  isAdmin: PropTypes.bool,
  customAction: PropTypes.node,
  record: PropTypes.object,
  basePath: PropTypes.string,
  deleteConfirmContent: PropTypes.string,
  deleteConfirmTitle: PropTypes.func,
  versionEditLinks: PropTypes.bool,
}

export default UtilityTariffListEditOrImportButton
